import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BasePage from "@/components/BasePage.vue";
import { PhArrowSquareOut } from "@phosphor-icons/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FinishPage',
  setup(__props) {

const handleOpenProjectWebsite = () => {
  window.open("https://github.com/Lukas-Stingl/eeg-collect", "_blank");
};
const handleOpenKITWebsite = () => {
  window.open("https://im.iism.kit.edu", "_blank");
};
const handleOpenContactForm = () => {
  window.open("https://im.iism.kit.edu/team_1261.php", "_blank");
};

return (_ctx: any,_cache: any) => {
  const _component_VCol = _resolveComponent("VCol")!
  const _component_VCardTitle = _resolveComponent("VCardTitle")!
  const _component_VCard = _resolveComponent("VCard")!
  const _component_VRow = _resolveComponent("VRow")!

  return (_openBlock(), _createBlock(BasePage, { heading: "Saved to KIT Server" }, {
    default: _withCtx(() => [
      _createVNode(_component_VCol, { class: "mb-14" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("p", { style: {"color":"#737373","text-align":"center","font-weight":"500","font-size":"18px"} }, [
            _createTextVNode(" Thank you for participating! "),
            _createElementVNode("br"),
            _createTextVNode(" The recording has ended and the data has been saved successfully. You can now close this website and return to the survey. ")
          ], -1)
        ])),
        _: 1
      }),
      _createVNode(_component_VCol, {
        class: "ga-3",
        style: {"width":"auto","max-width":"unset"}
      }, {
        default: _withCtx(() => [
          _cache[11] || (_cache[11] = _createElementVNode("h3", {
            class: "ml-5",
            style: {"color":"#737373"}
          }, "Learn more", -1)),
          _createVNode(_component_VRow, {
            class: "ga-4",
            style: {"flex-wrap":"nowrap"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VCard, {
                class: "pa-5 rounded-xl justify-lg-space-between",
                onClick: handleOpenProjectWebsite,
                style: {"width":"250px","height":"150px","display":"flex","flex-direction":"column","justify-content":"space-between"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PhArrowSquareOut), {
                    size: "18px",
                    style: {"position":"absolute","top":"20px","right":"20px"}
                  }),
                  _createVNode(_component_VCardTitle, null, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("The Project")
                    ])),
                    _: 1
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"13px"} }, " Thank you for participating! You can read more about this project here. ", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_VCard, {
                class: "pa-5 rounded-xl justify-lg-space-between",
                onClick: handleOpenKITWebsite,
                style: {"width":"250px","height":"150px","display":"flex","flex-direction":"column","justify-content":"space-between"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PhArrowSquareOut), {
                    size: "18px",
                    style: {"position":"absolute","top":"20px","right":"20px"}
                  }),
                  _createVNode(_component_VCardTitle, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("KIT WIN")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_VRow, { class: "w-100 d-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_VRow, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"13px"} }, " Learn more about the KIT Institute for Information Systems (WIN). ", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_VCard, {
                class: "pa-5 rounded-xl justify-lg-space-between",
                onClick: handleOpenContactForm,
                style: {"width":"250px","height":"150px","display":"flex","flex-direction":"column","justify-content":"space-between"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PhArrowSquareOut), {
                    size: "18px",
                    style: {"position":"absolute","top":"20px","right":"20px"}
                  }),
                  _createVNode(_component_VCardTitle, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Contact")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_VRow, { class: "w-100 d-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_VRow, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_VCol, { cols: "8" }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"14px"} }, " Dr. Michael Knierim ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_VRow, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_VCol, { cols: "3" }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"13px"} }, " Phone ", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_VCol, { cols: "8" }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"13px"} }, " +49 (721) 608-48385 ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_VRow, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_VCol, { cols: "3" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"13px"} }, " Mail ", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_VCol, { cols: "9" }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createElementVNode("p", { style: {"color":"#737373","text-align":"start","font-weight":"500","font-size":"13px"} }, " michael.knierim@kit.edu ", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})